import { TypeAnimation } from 'react-type-animation';
import './hero.scss';

const INITIAL_DELAY = 2000;
const DEFAULT_DELAY = 5000;

function Hero(props: any){
    const sequence: any[] = [
        "Tyler", INITIAL_DELAY,
        "a .NET developer", DEFAULT_DELAY,
        "a React developer", DEFAULT_DELAY,
        "a dungeon master", DEFAULT_DELAY,
        "a casual guitar player", DEFAULT_DELAY,
        "a dog owner", DEFAULT_DELAY, 
        "a gamer", DEFAULT_DELAY,
        "Tyler", DEFAULT_DELAY - INITIAL_DELAY,
    ];

    return (
        <section id="hero">
            <h1>Welcome, I'm&nbsp;
                <TypeAnimation className="animated-text"
                    sequence={sequence}
                    repeat={Infinity}
                    cursor={false}/>
                    !
            </h1>
            <div className="blurb">
                Fullstack develop at Wizards of the Coast.
            </div>
        </section>
    )
}

export default Hero;